import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl?.trim() || !supabaseAnonKey?.trim()) {
  const hint =
    'Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in Netlify: Site configuration → Environment variables → Add for production (and redeploy). Vite bakes these in at build time.';
  throw new Error(
    `Missing Supabase client env: need VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY. ${hint}`,
  );
}

export const supabase = createClient(supabaseUrl.trim(), supabaseAnonKey.trim());
